// extracted by mini-css-extract-plugin
module.exports = {"details":"Account_details__21sJC","list":"Account_list__9XhHx","settings":"Account_settings__1sOE2"};